import React from "react";
import SafeLink from "components/commons/SafeLink";
import styled from "styled-components";
import { WealthyEnv } from "helpers";
import { colors } from "nxtconstants";



const HowWealthyHelps = ({ helpsData = {} }) => {
  const {
    playStoreUrl, appStoreUrl,
    wealthyAi, appIcon, playStoreIcon, appStoreIcon,
    questionHeading,
    desktopHeading,
    mobileHeading,
    appName,
    downloadCount,
    featureData = []
  } = helpsData;
  return (
    <Section>
      <Container>
        <Header>
          <QuestionHeading>{questionHeading}</QuestionHeading>
          <DesktopHeading>{desktopHeading}</DesktopHeading>
          <MobileHeading>{mobileHeading}</MobileHeading>
        </Header>

        <ContentWrapper>
          <VisualContent>
            <Image
              src={wealthyAi}
              alt="Wealthy AI Powered App Interface for Mutual Fund Distributors"
              width={1000}
              height={1000}
              sizes="(max-width: 768px) 90vw, min(40rem, 45vw)"
              loading="lazy"
              decoding="async"
            />
          </VisualContent>

          <TextContent>
            <FeatureSection>
              <FeatureList>
                {featureData.map((feature) => (
                  <FeatureItem key={feature.id}>
                    <FeatureIcon
                      src={feature.icon}
                      alt={feature.altText}
                      width={24}
                      height={24}
                      loading="lazy"
                      decoding="async"
                    />
                    <FeatureText>
                      {feature.text}
                    </FeatureText>
                  </FeatureItem>
                ))}
              </FeatureList>
            </FeatureSection>
          </TextContent>
        </ContentWrapper>

        <DownloadSection>
          <AppInfo>
            <AppIcon src={appIcon} alt="Wealthy Partner App Icon" width={160} height={160} decoding="async" />
            <AppDetails>
              <AppName>Download Wealthy Partner App</AppName>
              <DownloadCount>100k + Downloads</DownloadCount>
            </AppDetails>
          </AppInfo>
          <StoreButtons>
            <SafeLink
              href={playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StoreIcon
                src={playStoreIcon}
                alt="Google Play Store Icon"
                width={224}
                height={67}
                loading="lazy"
                decoding="async"
              />
            </SafeLink>

            <SafeLink
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StoreIcon
                src={appStoreIcon}
                alt="App Store Icon"
                width={224}
                height={67}
                loading="lazy"
                decoding="async"
              />
            </SafeLink>
          </StoreButtons>

        </DownloadSection>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  background: ${colors.white};
  overflow-x: hidden; 

  @media (max-width: 768px){
    padding: 0px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  margin-bottom: 10rem;
  width: 85%;
  max-width: 125rem;

  @media(max-width: 768px){
    margin-bottom: 5.6rem;
    width: 85%;  
    box-sizing: border-box; 
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2.5rem;
`;

const ContentWrapper = styled.div`
  width: 90%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: start;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    margin: 0 auto;
    grid-template-columns: 1fr;
    gap: 2rem;
    width: 100%; 
  }
`;

const VisualContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 2rem;
  box-shadow: 0 .4rem 2.4rem rgba(0,0,0,0.08);
  margin-bottom: 5rem;
  max-width: 100%; 

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 2rem;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  overflow-x: hidden; 
`;

const QuestionHeading = styled.h2`
  font-family: 'Lato';
  font-size: 3rem;
  color: ${colors.balck};
  font-weight: 400;
  margin: 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    color: ${colors.textGray};
    font-weight: 400;
  }
`;

const DesktopHeading = styled.h2`
  font-family: 'DM Serif Display';
  font-size: 5rem;
  font-weight: 400;
  color: ${colors.textBlack};
  margin: 0.25rem 0 0;
  text-align: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileHeading = styled.h2`
  font-family: 'DM Serif Display';
  font-size: 2.7rem;
  font-weight: 400;
  color: ${colors.textBlack};
  margin: 0.25rem 0 0;
  text-align: center;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const FeatureSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
  width: 100%; 

  @media(max-width: 768px) {
    gap: 2.7rem;
    width: 100%; 
    padding: 0; 
  }
`;

const FeatureTitle = styled.h3`
  font-family: 'Lato';
  font-size: 3rem;
  font-weight: 400;
  color: ${colors.textBlack};
  margin: 0;

  @media(max-width: 768px){
    font-size: 2.3rem;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding-top: 2.5rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 100%; 

  @media(max-width: 768px) {
    gap: 0;
    width: 100%; 
    padding:0;
    max-width: 100%; 
  }
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  width: 100%; 
  @media(max-width: 768px) {
    gap: 0.8rem; 
  }
`;

const FeatureIcon = styled.img`
  width: 2.4rem;
  height: 2.4rem;
  flex-shrink: 0;
  margin-top: .6rem;
  margin-right: 1rem;

  @media(max-width: 768px){
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 1rem; 
  }
`;

const FeatureText = styled.p`
  font-family: 'Lato';
  font-size: 2rem;
  color: ${colors.textBlack};
  line-height: 3.2rem;
  font-weight: 400;
  margin-bottom: 4rem;
  word-wrap: break-word; 
  overflow-wrap: break-word; 
  hyphens: auto; 

  @media( max-width: 768px){
    font-size: 1.6rem;
    margin-bottom: 2.7rem;
    line-height: 2.4rem; 
  }
`;

const DownloadSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 2rem 3rem;
  background: #F7F9FF;
  border-radius: 2.4rem;
  width: 90%;
  margin: auto;
  gap: 8rem; 

  @media (max-width: 1024px) {
    gap: 4rem;
    padding: 1.5rem 2rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    padding: 1.5rem;
  }
`;

const AppInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1; 
  min-width: 280px;

  @media (max-width: 768px) {
    justify-content: center;
    text-align: center;
  }
`;

const AppIcon = styled.img`
  width: clamp(5rem, 6vw, 8rem);
  height: clamp(5rem, 6vw, 8rem);
  border-radius: 1rem;
`;

const AppDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  overflow: hidden; 
`;

const AppName = styled.div`
  font-family: 'Lato';
  font-size: clamp(1.6rem, 2vw, 2.4rem);
  font-weight: 700;
  color: ${colors.textBlack};
  width: auto;
  max-width: 100%;
  word-wrap: break-word; 
`;

const DownloadCount = styled.div`
  font-family: 'Lato';
  font-size: clamp(1.2rem, 1.5vw, 2rem);
  color: ${colors.textGray};
`;

const StoreButtons = styled.div`
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const StoreIcon = styled.img`
  width: clamp(10rem, 15vw, 14rem);
  height: auto;
`;


export default HowWealthyHelps;